import { IconSettings, IconSparkles } from '@tabler/icons-react';
import { Button } from 'design-system/button/button';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from 'design-system/tooltip/tooltip';
import { cn } from 'lib/cn';
import { Link } from 'react-router';
import { routes } from 'routes/routes';

import { SidebarNavItem } from './sidebar-nav-item';

export interface SidebarFooterProps {
  onAskAi: () => void;
  /** Hidden on a surface that already is the settings nav. */
  showSettings?: boolean;
  /** Renders the Settings control as a button calling this instead of a navigating link. */
  onSettingsSelect?: () => void;
  collapsed?: boolean;
}

export const SidebarFooter = ({
  onAskAi,
  showSettings = true,
  onSettingsSelect,
  collapsed = false,
}: SidebarFooterProps) => {
  const kapaAgentButton = (
    <Button
      variant="secondary"
      size="default"
      onClick={onAskAi}
      aria-label="Kapa Agent"
      className={cn(
        'w-full justify-center overflow-hidden',
        collapsed && 'gap-0 px-1',
      )}
    >
      <IconSparkles stroke={1.5} />
      <span
        className={cn(
          'overflow-hidden whitespace-nowrap transition-[max-width,opacity]',
          collapsed ? 'max-w-0 opacity-0' : 'max-w-[160px]',
        )}
      >
        Kapa Agent
      </span>
    </Button>
  );

  return (
    <div
      className={cn('py-4 transition-[padding]', collapsed ? 'px-2' : 'px-4')}
    >
      <div className="flex flex-col gap-3">
        {showSettings ? (
          <SidebarNavItem
            label="Settings"
            collapsed={collapsed}
            icon={IconSettings}
            render={
              onSettingsSelect ? (
                <button
                  type="button"
                  onClick={onSettingsSelect}
                  aria-label="Settings"
                />
              ) : (
                <Link
                  to={routes.settingsAccount.build()}
                  aria-label="Settings"
                />
              )
            }
          />
        ) : null}

        <Tooltip disabled={!collapsed}>
          <TooltipTrigger render={kapaAgentButton} />
          <TooltipContent side="right">Kapa Agent</TooltipContent>
        </Tooltip>
      </div>
    </div>
  );
};
